import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TendersListComponent } from './_components/tenders-list/tenders-list.component';
import { TendersListRoutingModule } from './tenders-list-routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HighlightPipe } from '../tenders/_pipes/highlight.pipe';
import { WordSlicePipesModule } from '../tenders/_pipes/word-slice.pipe.module';
import { StateFilterPipe } from '../tenders/_pipes/state-filter.pipe';

import { KeywordsSectionModule } from './../tenders/_components/keywords-section/keywords-section.module';
import { KeywordsListComponent } from '../tenders/_components/keywords-list/keywords-list.component';
import { FaqListingPageModule } from './../shared/_components/faq-lisiting/faq-listing-page.module';
import { CredlixAdsListingModule } from './../shared/_components/credlix-ads-listing-page/credlix-ads-listing-page.module';
import { ListingCardComponent } from './../tender-listing/_components/listing-card/listing-card.component';
import { PipesModule } from '../tenders/_pipes/amount-pipes.module';

import { SimilarTenderModule } from './../shared/_components/similar-tender/similar-tender.module';
import { SigninWithOtpModule } from "./../auth/_components/signin-with-otp/signin-with-otp.module";
import { TrendingSectionComponent } from '../shared/_components/trending-section/trending-section.component';

import { IndianNumberPipesModule } from './../tenders/_pipes/indian-number-pipes.module';
import { BlogSliderModule } from './../blog/shared/blog-slider/blog-slider.module';

import { CommonSideCardModule } from './../tender-details/_components/common-side-card/common-side-card.module';
import { NumberFormatterPipesModule } from './../tenders/_pipes/number-formatter.pipe.module';

@NgModule({
  declarations: [
    TendersListComponent,
    HighlightPipe,
    StateFilterPipe,
    KeywordsListComponent,
    ListingCardComponent,
    TrendingSectionComponent
  ],
  imports: [
    CommonModule,
    TendersListRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    KeywordsSectionModule,
    CredlixAdsListingModule,
    SigninWithOtpModule,
    WordSlicePipesModule,
    SimilarTenderModule,
    IndianNumberPipesModule,
    BlogSliderModule,
    FaqListingPageModule,
    CommonSideCardModule,
    NumberFormatterPipesModule
  ]
})

export class TendersListModule { }
